module.exports = __webpack_public_path__ + "img/numberThree.3de9cec0.png";